import React from "react";
import styles from "./Billboard.module.css";
import { Link } from "react-router-dom";
import DesignShowcase from "../../components/designShowcase/DesignShowcase";
import LineAnimation from "../../components/lineAnimations/LineAnimation";
import LineAnimationTwo from "../../components/lineAnimationsTwo/LineAnimationTwo";
import FAQ from "../../components/faq/Faq";

const Billboard = () => {
  return (
    <>
      <div className={styles.pageBck}>
        <LineAnimation />
        <LineAnimationTwo />
        <div className={styles.pageBanner}>
          <h1>Billboard</h1>
          <span>ADVERTISING BOARDS</span>
          <p>
            Lë një ndikim të madh me dizajnet e billboardeve me impakt të lartë nga Bold. 
            Nga printimi tradicional deri te ekranet digjitale dinamike, ne krijojmë billboarde që tërheqin vëmendjen.
          </p>
          <div className={styles.pageButtons}>
            <Link to="/contact">Na kontaktoni</Link>
          </div>
        </div>
      </div>

      <DesignShowcase
        reverse="reverse"
        image="/assets/images/banner.webp"
        title="Dallohu me Billboarde Që Tërheqin Vëmendjen!"
        text="Lë një ndikim të madh me dizajnet e billboardeve me impakt të lartë nga Bold…"
        keyOne="Billboarde me Printim të Lartë – Dizajne të qarta dhe të gjalla për maksimumin e dukshmërisë."
        keyTwo="Billboarde Digjitale – Ekrane të programueshme për mesazhe dinamike."
        keyThree="Opsione Ekologjike – Materiale të qëndrueshme për një reklamim më të gjelbër."
      />

      <div className={styles.callUs}>
        <div className="subContainer">
          <h2>Gati për të nisur projektin tuaj?</h2>
          <Link to="/contact">Dërgo email</Link>
        </div>
      </div>

      <FAQ />
    </>
  );
};

export default Billboard;

